import { PayloadAction } from "@reduxjs/toolkit";

// State definition
export type ApplicationLayoutState = {
  readonly type: ThemeTypes;
  readonly primaryColor: ThemeColors;
  readonly secondaryColor: ThemeColors;
  readonly isSidebarOpen: boolean;
};

// Action types definition
export enum ApplicationLayoutActionTypes {
  SET_THEME = "@@applicationLayout/SET_THEME",
  SET_PRIMARY = "@@applicationLayout/SET_PRIMARY",
  SET_SECONDARY = "@@applicationLayout/SET_SECONDARY",
  SET_SIDEBAR = "@@applicationLayout/SET_SIDEBAR",
}

// Additional definitions used in action objects
export type ThemeTypes = "light" | "dark";

export enum ThemeColors {
  amber,
  blue,
  blueGrey,
  brown,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
}

// Actions definition
export type SetThemeAction = PayloadAction<ThemeTypes, ApplicationLayoutActionTypes.SET_THEME>;
export type SetPrimaryAction = PayloadAction<ThemeColors, ApplicationLayoutActionTypes.SET_PRIMARY>;
export type SetSecondaryAction = PayloadAction<ThemeColors, ApplicationLayoutActionTypes.SET_SECONDARY>;
export type SetSidebarAction = PayloadAction<boolean, ApplicationLayoutActionTypes.SET_SIDEBAR>;

export type ApplicationLayoutActions = SetThemeAction | SetPrimaryAction | SetSecondaryAction | SetSidebarAction;
